import { TAffairKind } from "@api/affair.int";
import { Box, BoxProps, Button, ButtonProps, Heading, HeadingProps, Icon, IconButton, Image, Link, LinkProps } from "@chakra-ui/react";
import React, { useEffect } from "react";
import { FaBullhorn } from "react-icons/fa";
import { IconType } from "react-icons/lib";
import { MdArrowBack, MdArrowForward, MdClose, MdLock, MdMenu } from "react-icons/md";
import { NavLink, NavLinkProps, useLocation, useNavigate } from "react-router";
import { NYIL_BACK, NYIL_BTN } from "theme";
import { AFFAIR_KINDS, Bogyo } from "./appComponents";
import { MAP_NAV_ROOT_EMPTY, TMapNavRoot, useVVStore } from "./store";
import { useDeepAuth } from "./api";
import { TProtectionLevel } from "features/auth/DeepAuth";
import { useVVNav } from "./vvNav";

export function VizvColumn({ ...rest }: BoxProps) {
	return <Box
		flexShrink={0} flexGrow={0}
		overflowX='hidden' overflowY='auto'
		{...rest} />
}


export interface VizvMainColProps extends BoxProps {
	mapNavRoot?: TMapNavRoot|string;
	isTool?: { width: number, isDetailed: boolean, isMainMapTool?: boolean };
	isDetail?: boolean;
}


export function VizvMainCol({ children, isTool, mapNavRoot=MAP_NAV_ROOT_EMPTY, isDetail = false, ...rest }: VizvMainColProps) {
	const isMobile = useVVStore(state => state.isMobile());
	const setLayoutPush = useVVStore(state => state.setLayoutPush);
	const setTool = useVVStore(state => state.setTool);
	const MAIN_WIDTH = useVVStore(state => state.getMainWidth());
	const DETAILS_WIDTH = useVVStore(state => state.getDetailsWidth());
	const CENTERED_WIDTH = isDetail ? DETAILS_WIDTH : MAIN_WIDTH;
	const TOOL_WIDTH = useVVStore(state => state.getToolsWidth());
	const vvNav = useVVNav();


	useEffect(() => {

		if (!isDetail) {
			setTool(isTool?.width || 0, isTool?.isDetailed || false);
			if (isMobile) {

				if (isTool) {
					if (isTool.isMainMapTool) {

					} else {
						setLayoutPush((isTool.isDetailed ? 'menu_and_tools' : 'menu'));
						console.log('ÉÉÉÉNNNNN', isTool.isDetailed ? 'menu_and_tools' : 'menu')
					}
				} else {
					setLayoutPush('menu');
				}
			}
			vvNav.setRoot(mapNavRoot);
			return () => {
				setTool(0, false);
				vvNav.clearRoot();
			}

		}


	}, [isDetail, isMobile, isTool?.isDetailed, isTool?.width, mapNavRoot]);


	const showDebug = false;

	if (isMobile)
		return <VizvColumn
			className='vizv-main-outer-sm' background={showDebug ? '#0f04' : undefined}
			width={MAIN_WIDTH} // mindig 100vw
		>
			<Box className='vizv-main-inner' p={4} pb='4em' {...rest} >
				{children}
			</Box>
		</VizvColumn>;

	//
	if (!isTool)
		return <VizvColumn
			className='vizv-main-outer-lg-center' background={showDebug ? '#0f04' : undefined}
			width={CENTERED_WIDTH}
			display='flex' flexDir='column'
			alignItems='safe center' justifyContent='flex-start'
			transition='width .2s ease-out'
		>
			<Box flex='0 1 10%'></Box>
			<Box className='vizv-main-inner' px='2em' maxW='1200px' minW='500px' minH='300px' {...rest} >
				{children}
			</Box>
			<Box flex='0 1 30%'></Box>
		</VizvColumn>;

	// --------- left (tool )-----------
	return <VizvColumn
		className='vizv-main-outer-lg-left' background={showDebug ? '#0f04' : undefined}
		width={TOOL_WIDTH}
		display='flex' flexDir='column'
	>
		<Box className='vizv-main-inner' pt={2} px={8} {...rest} >
			{children}
		</Box>
	</VizvColumn>;


}

export interface VizvCardProps extends BoxProps {
	isTool?: boolean;
	onClose?: () => void;
	onBack?: () => void;
	isClosable?: boolean;
}

export function VizvCard({ children, isTool = false, isClosable = false, onClose, onBack, ...rest }: VizvCardProps) {
	const isMobile = useVVStore(state => state.isMobile());
	const layoutPush = useVVStore(state => state.layoutPush);
	const setLayoutPush = useVVStore(state => state.setLayoutPush);
	const nav = useNavigate();
	const loc = useLocation();
	const isMap = loc.pathname === '/map' || loc.pathname === '/map/';
	if (isClosable && !onClose) {
		onClose = () => {
			nav('/map');
			if (isMobile)
				setLayoutPush('no');
		}
	}

	let showCloseBtn = !!onClose;
	if (isMobile && isTool)
		showCloseBtn = false;
	if (isTool && layoutPush === 'menu')
		showCloseBtn = false;


	return <Box
		className='vizv-card popupart'
		bg="cardbg.main"
		boxShadow='vvcard' borderRadius="6px"
		display='flex' flexDir='column' position='relative'
		{...rest}
		maxWidth='100vw'
		pointerEvents='all' css={{ 'touch-action': 'all' }}

	>
		{isTool && layoutPush === 'menu' && <Box
			//bg="cardbg.main"
			display='flex' flexDir='row' justifyContent='flex-start' alignItems='center'
			px={2} pt={2}
			pointerEvents='all' css={{ 'touch-action': 'all' }}
		>
			{onBack && <IconButton icon={<MdArrowBack />} aria-label="vissza" size='md' variant='ghost' onClick={onBack} />}
			<Box _hover={{ bg: '#fff1' }}>
				<Image src='/logo/vizvedok_neg2_100.png' height='30px' onClick={() => setLayoutPush('no')} cursor='pointer' />
			</Box>
			{/*<IconButton icon={<MdMenu />} aria-label="menu" size='md' variant='ghost' onClick={() => setLayoutPush('no')} />*/}
			{/*!(isMobile && !isMap) &&*/ onClose && <IconButton ml='auto' icon={<MdClose />} aria-label="close" size='md' variant='ghost' onClick={onClose} />}
			{/*isMobile && !isMap && <Button rightIcon={<MdArrowForward />} aria-label="menu" size='sm' variant='ghost' fontWeight='400' onClick={() => setLayoutPush('menu_and_tools')} >Nagy térkép</Button>*/}
		</Box>}
		{children}
		{showCloseBtn && <Box position='absolute' right='-10px' top='-10px' borderRadius='md'
			bg="cardbg.main" boxShadow='0px 0px 4px -1px #8fcee5d9' zIndex={101} _hover={{bg: 'primary.800'}}
			display='flex' alignItems='stretch' justifyContent='stretch' w='32px' h='32px'
		><IconButton aria-label="bezár" variant='link' onClick={onClose} size='sm' icon={<MdClose />} />
		</Box>}
	</Box>
}

// --------------------------------------------------------------------- CARD ELEMS -----------------------------------
// -------------------------- PADDING --------------------------
export function VizvCardContent(rest: BoxProps) {
	return <Box p={3} {...rest} />
}
export function VizvCardActionStrip(rest: BoxProps) {
	return <Box display='flex' flexDir='row' alignItems='center' justifyContent='space-between' {...rest} py={3} pl={3} />
}

export function VizvButtonCancel(rest: ButtonProps & { to?: string }) {
	return <Button as={NavLink} size='md' variant='solid' colorScheme='gray' fontWeight='500'
		borderRadius={0}
		{...rest}
	/>
}
export function VizvButtonBack(rest: ButtonProps) {
	return <Button variant='solid' colorScheme='gray' fontWeight='500'
		borderRadius={0}
		leftIcon={<MdArrowBack />}
		{...rest}
	/>
}

export interface VizvButtonPrimaryProps extends ButtonProps {
	protLev?: TProtectionLevel;
}

export function VizvButtonPrimary({ protLev = 'confirmed', onClick: pOnClick, ...rest }: VizvButtonPrimaryProps) {
	const isMobile = useVVStore(state => state.isMobile());
	const auth = useDeepAuth();
	const protFailed = auth.protectionFailed(protLev);
	const onClick = (e: React.MouseEvent) => {
		if (protFailed) {
			e.preventDefault();
			auth.showSignIn();
		} else {
			if (pOnClick)
				pOnClick(e as any);
		}
	}

	return <Button variant='solid' colorScheme='secondary' fontWeight='500'
		borderRadius={0}
		{...isMobile
			? {
				left: '1em',
			}
			: {
				left: '2em',
				_hover: { 'transform': 'translate(6px, 0px)' },
				transition: `transform .2s ease-out`,
			}
		}
		//{...leftIcon ? { leftIcon } : { rightIcon: <MdArrowForward /> }}
		onClick={onClick}
		rightIcon={<MdArrowForward />}


		{...rest}
		{...!!protFailed && { leftIcon: <MdLock /> }}
	/>
}



export interface VizvCardHeaderProps extends BoxProps {
	isMainLogo?: boolean;
	warning?: boolean;
	isModal?: boolean;

}
export function VizvCardHeader({ children, isMainLogo = false, warning = false, isModal = false, ...rest }: VizvCardHeaderProps) {
	const isMobile = useVVStore(state => state.isMobile());
	const setLayoutPush = useVVStore(state => state.setLayoutPush);

	const elem = <Heading className='vv-h1' as='h1' {...rest}
		display='flex' alignItems='center' flexDir='row'
		background='primary.main' color='#000' p='.2em .6em'
		boxShadow='vvtitle'
		mb={4} mt={isMobile ? -2 : '30px'}
		position='relative'
		left={isMobile ? -1 : -3}
		overflow='visible'
		fontSize={isMobile ? '3xl !important' : '5xl !important'}
		fontWeight='400'
		width='fit-content'
		pointerEvents='all' css={{ 'touch-action': 'all' }}
		textShadow='1px 1px 1px #fff2'
		{...warning && { background: '#db4545' }}
		{...rest}
	>
		{children}
	</Heading>

	if (!isMobile || isModal)
		return elem;
	else
		return <>
			<Box position='sticky' top='-1px' zIndex={100} >
				<Box
					bg="cardbg.main"
					display='flex' flexDir='row' justifyContent='space-between'
					p={2}
					pointerEvents='all' css={{ 'touch-action': 'all' }}
				>
					<Box _hover={{ bg: '#fff1' }}>
						<Image src={`/logo/vizvedok_neg2_${isMainLogo ? '400' : '100'}.png`} height='30px'
							{...isMainLogo && { height: '80px', pb: 4 }}
							onClick={() => setLayoutPush('no')} cursor='pointer'
						/>
					</Box>
					<IconButton icon={<MdMenu />} aria-label="menu" size='md' variant='ghost' onClick={() => setLayoutPush('no')} />
				</Box>
			</Box>
			<Box position='sticky' top={isMainLogo ? '50px' : '10px'} zIndex={100} width='fit-content' >
				{elem}
			</Box>
		</>
}

// -------------------------- HEADER H2 --------------------------
export interface VizvCardHeaderPopupProps extends BoxProps {
	variant: 'blue' | 'green';

}


export function VizvCardHeaderPopup({ variant, ...rest }: VizvCardHeaderPopupProps) {
	return <Box className='vv-h2' as='h2'
		position='relative' left='-.3em' boxShadow='vvtitle'
		display='flex' flexDir='row' alignItems='center'
		{...variant === 'green' && { color: '#000', background: 'secondary.main' }}
		{...variant === 'blue' && { color: '#000', background: 'primary.main', textShadow: '1px 1px 1px #fff2' }}
		fontSize='3xl !important'
		fontWeight='400'
		width='fit-content'
		p='7px 1em'
		mt={3}

		{...rest} />
}



export interface VizvCardHeader2Props extends BoxProps {
	kind: TAffairKind
}

export function VizvCardHeader2({ kind, children, ...rest }: VizvCardHeader2Props) {
	return <Box className="vizvx-title-with-kind"
		bg={AFFAIR_KINDS[kind].color}
		display='flex' flexDir='row' alignItems='center'
		position='relative' left='-7px' color='#fff'
		pr={2} py={1} my={1} boxShadow='vvtitle'
		{...rest}
	>
		<Box px={2}>
			<Bogyo kind={kind} />
		</Box>
		<Box fontSize='larger' whiteSpace='nowrap' overflow='hidden' textOverflow='ellipsis'
		>{children}</Box>
	</Box>
}


// =================================================== ACTION ==========================================
// -------------------------- HEADER H2 --------------------------

export interface VizvCardActionProps extends BoxProps, Partial<Pick<NavLinkProps, 'to'>> {
	isLeft?: boolean;
	isBlank?: boolean;
	protLev?: TProtectionLevel;
}

export function VizvCardAction({ isLeft = false, isBlank = false, protLev = 'confirmed', onClick: pOnClick, children, ...rest }: VizvCardActionProps) {
	isLeft = 13 % 2 === 0;
	const isMobile = useVVStore(state => state.isMobile());
	const auth = useDeepAuth();
	const protFailed = auth.protectionFailed(protLev);
	const onClick = (e: React.MouseEvent) => {
		if (protFailed) {
			e.preventDefault();
			auth.showSignIn();
		} else {
			if (pOnClick)
				pOnClick(e as any);
		}
	}

	return <Box as={NavLink}
		className='bigaction'
		boxShadow='vvtitle'
		position='relative'
		color='#000'
		//background='secondary.main'
		background='secondary.main'
		fontSize='xl !important' fontWeight='400'
		width='fit-content'
		p='7px 1em'
		ml='auto'
		textAlign='right'
		onClick={onClick}
		display='flex' flexDir='row' alignItems='center' gap={1} lineHeight='normal'

		{...isBlank && { target: '_blank' }}

		{...isMobile
			? {
				left: '.3em',
			}
			: {
				left: '.3em',
				_hover: { 'transform': 'translate(8px, 0)' },
				transition: `transform .2s ease-out`,
			}
		}

		{...isLeft && {
			ml: 0,
			left: '-.3em',
			_hover: { transform: 'translate(-8px, 0)' }
		}}

		{...rest} >
		{isLeft && <Box as='span' fontFamily='initial' ><>{NYIL_BACK}&nbsp;</></Box>}
		{!isLeft && protFailed && <Box as='span' fontFamily='initial' ><Icon as={MdLock} /></Box>}
		{children}
		{!isLeft && <Box as='span' fontFamily='initial' >&nbsp;{NYIL_BTN}</Box>}
		{isLeft && protFailed && <Box as='span' fontFamily='initial' >&nbsp;<Icon as={MdLock} /></Box>}


	</Box>
}

export interface VizvCardAction2Props extends BoxProps, Partial<Pick<NavLinkProps, 'to'>> {
	isBlank?: boolean;
	icon?: React.ReactNode;
}
export function VizvCardAction2({ isBlank = false, children, icon, onClick:pOnClick, ...rest }: VizvCardAction2Props) {
	const isMobile = useVVStore(state => state.isMobile());
	// EZ VAJON MIÉRT KELL?????????
	const onClick = () => {
		setTimeout((e: React.MouseEvent<HTMLDivElement>) => {
			if (pOnClick) pOnClick(e);
		}, 0)
	}

	return <Box
		position='relative'
		className='bigaction2'
		boxShadow='lg'
		fontSize='xl !important' fontWeight='400'
		ml='auto'
		display='flex' flex='row' alignItems='center'
		left='1em'

	>
		{icon}
		<Box as={NavLink}
			color='#000'
			background='secondary.main'
			width='fit-content'
			p='7px 1em'
			textAlign='right'
			{...isBlank && { target: '_blank' }}
			{...!isMobile && {
				left: '1em',
				_hover: { 'transform': 'translate(8px, 0)' },
				transition: `transform .2s ease-out`,
			}
			}

			onClick = {onClick}
			{...rest} >
			{children}
			<Box as='span' fontFamily='initial' >&nbsp;{NYIL_BTN}</Box>


		</Box>
	</Box>
}



export function VizKoalicioLink({ children, ...rest }: LinkProps) {
	if (!children)
		children = 'Víz Koalíció';
	return <Link className="xx2" href='https://vizkoalicio.cka.hu/' target='_blank' color='#fbea72 !important' {...rest} >{children}</Link>;
}

export function PeticioLinkx({ ...rest }: LinkProps) {
	return <Link className="xx2" href='https://szabad.ahang.hu/petitions/tiszta-vizet-a-poharainkba' target='_blank' {...rest} />;
}
export function PeticioLink({ children, ...rest }: LinkProps) {
	return <NavLink target="_blank" to={`https://szabad.ahang.hu/petitions/tiszta-vizet-a-poharainkba`}



	><Box className="xx2" display='flex' flexDir='row' position='relative' alignItems='center' >
			<Box bg='#23b1eb' color='#000d' position='absolute' mr='1em' p='5px'
				display='flex' alignItems='center' justifyContent='center'
				boxShadow='2px 2px 2px #000c'
			>
				<Icon as={FaBullhorn} />
			</Box>
			<Box pl='2em'>

				{children}
			</Box>
		</Box>
	</NavLink>



}

export function FecebookLink({ ...rest }: LinkProps) {
	return <Link className="xx2" href='https://www.facebook.com/vizkoalicio' target='_blank' {...rest} />;
}

export function CkaHirekLink({ ...rest }: LinkProps) {
	return <Link className="xx2" href='https://www.cka.hu/viz-koalicio' color='#fbea72  !important' target='_blank' {...rest} />;
}

export function CardContentHead1({ ...rest }: HeadingProps) {
	return <Heading
		size='md' as='h4'
		fontSize='xl' fontWeight='400' mb={4}  //lineHeight='.8'
		//bg='#1b354c' 
		bg='rgb(38 74 105)' 
		lineHeight='1.5'
		color='#fffd'
		textShadow='1px 1px #0009'
		left='-1em'
		position='relative'
		padding='5px 1em'
		width='fit-content'
		mt='6px'
		boxShadow='lg'
		{...rest}
	/>
}

export function CardContentHead2({ ...rest }: HeadingProps) {
	return <Heading
		size='md' as='h4'
		fontSize='2xl' fontWeight='400'
		mb={2}
		position='relative'
		borderBottom='1px solid #fff3'
		{...rest}
	/>
}

export function ArticleRightImage({ src, width, ...rest }: (BoxProps & { src: string, width: 300 | 400 })) {
	const isMobile = useVVStore(state => state.isMobile());
	const isFull = useVVStore(state => state.isFull());
	return <Box
		flex={!isFull ? '0 0 100%' : `0 0 ${width}px`}
		width={!isFull ? '100%' : `${width}px`}
		dropShadow='xl'
		pb={3}
		{...isFull && { mr: '-30px', mt: '-70px' }}
	>
		<Image src={src} objectFit='cover' border='3px solid #0008' borderRadius='sm' width='100%' />
	</Box>

}

export function ArticleRightImage2({ src, width, ...rest }: (BoxProps & { src: string, width: 300 | 400 })) {
	const isMobile = useVVStore(state => state.isMobile());
	const isFull = useVVStore(state => state.isFull());
	return <Box
		flex={isMobile ? '0 0 100%' : `0 0 400px`}
		bg="cardbg.main"
		width='400px' height='250px'
		display='flex' justifyContent='center' alignItems='center'
		dropShadow='xl'
		border='3px solid #0008' borderRadius='sm'
		pb={3}
	//{...isFull && { mr: '-30px', mt: '-70px' }}
	>
		<Image src={src} objectFit='cover' width='350px' />
	</Box>

}